// Google Places Autocomplete SESSION TOKEN for one address box.
//
// One token is created when the visitor STARTS typing (not when the page loads), reused for every keystroke of that search, handed to the
// final Place Details call, and then dropped (end()) so the NEXT search gets a fresh one. Google bills a session as one unit only while the
// token is used inside a few minutes, so a token that has been idle for 2 minutes (or is older than ~2.8 minutes) is replaced: someone
// who types, wanders off and comes back must not keep reusing a dead session.
const defaultUuid = () =>
  (typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `s${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`);

export const IDLE_MS = 120000;
export const MAX_AGE_MS = 170000;

export const createPlacesSession = ({ now = () => Date.now(), uuid = defaultUuid, idleMs = IDLE_MS, maxAgeMs = MAX_AGE_MS } = {}) => {
  let token = null;
  let startedAt = 0;
  let lastUsedAt = 0;
  return {
    // the token to send with a suggestions request or the details call (creates one on first use / after idle or expiry)
    get() {
      const t = now();
      if (!token || t - lastUsedAt > idleMs || t - startedAt > maxAgeMs) {
        token = uuid();
        startedAt = t;
      }
      lastUsedAt = t;
      return token;
    },
    // the search is finished (an address was picked): the next keystroke starts a new session
    end() {
      token = null;
    },
    active() {
      return token !== null;
    },
  };
};
